// Assets
import stock1 from '../../../assets/pictures/stock1.jpg';
import stock2 from '../../../assets/pictures/stock2.jpg';
import stock3 from '../../../assets/pictures/stock3.jpg';

// Models
import {
  Change,
  ChangeType,
  ContactChangeType,
  DashboardCommunity,
  RoomChangeType,
  ToolChangeType,
  ToolFavorite,
} from '../models/dashboard.types';
import { RoomType } from '../../newscenter/models/news-center.types';
import {
  TemplateStatus,
  TemplateType,
  TemplateUseCase,
} from '../../templates/models/templates.types';
import { MarketTemplate } from '../../market/models/market.types';
import { InfoMessageType } from '../../newscenter/models/message.types';

/**
 * GET Changes mock data.
 * @returns Changes mock data
 */
export const changesMock: Change[] = [
  //      Tools
  {
    id: '609cba3a-7db2-47a4-8c13-fb7633e89fe4',
    type: ChangeType.Tool,
    duplicated_ids: 'dd135',
    create_change_info: {
      changed_at: new Date(2022, 6, 10, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 10, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    favorite: false,
    read: false,
    tool: {
      id: '609cba3a-7db2-47a4-8c13-fb7633e89fe4',
      create_change_info: {
        changed_at: new Date(2022, 6, 9, 17, 31).toISOString(),
        created_at: new Date(2022, 6, 9, 16, 31).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Petra',
              last_name: 'Meyer',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'Rose',
              last_name: 'Baum',
            },
          },
        },
      },
      count: 9,
      tool_name: 'ToolA',
      user_1_name: 'Max',
      community: {
        id: '1234dkj-54361ewcvad',
        name: 'Communtiy 1',
      },
      change_type: ToolChangeType.Create,
    },
  },
  {
    id: '609cba3a-7db2-47a4-8c13-fb7633e89fe4',
    type: ChangeType.Tool,
    duplicated_ids: 'ds3135',
    create_change_info: {
      changed_at: new Date(2022, 6, 10, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 10, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: true,
    tool: {
      id: '609cba3a-7db2-47a4-8c13-fb7sgdf3e89fe4',
      create_change_info: {
        changed_at: new Date(2022, 6, 9, 17, 31).toISOString(),
        created_at: new Date(2022, 6, 9, 16, 31).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Petra',
              last_name: 'Meyer',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'Rose',
              last_name: 'Baum',
            },
          },
        },
      },
      count: 9,
      tool_name: 'ToolA',
      user_1_name: 'Max',
      community: {
        id: '1234dkj-54361ewcvad',
        name: 'Communtiy 1',
      },
      change_type: ToolChangeType.MultiRowAdd,
    },
  },
  {
    id: '609cba3a-7db2-47a4-8c13-fb7633e89fe4',
    type: ChangeType.Tool,
    duplicated_ids: '356d135',
    create_change_info: {
      changed_at: new Date(2022, 6, 10, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 10, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '609cba3a-7db2-47a4-8c13-fb7633e89fe4',
      create_change_info: {
        changed_at: new Date(2022, 6, 11, 17, 31).toISOString(),
        created_at: new Date(2022, 6, 11, 16, 31).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Petra',
              last_name: 'Meyer',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'Rose',
              last_name: 'Baum',
            },
          },
        },
      },
      count: 9,
      tool_name: 'ToolA',
      user_1_name: 'Max',
      community: {
        id: '1234dkj-54361ewcvad',
        name: 'Communtiy 1',
      },
      changed_row: {
        multi_element_name: 'Gruppierter Mehrfacheintrag',
        column_name: 'number',
        old_value: '123',
        new_value: '12345',
      },
      change_type: ToolChangeType.MultiRowUpdate,
    },
  },
  {
    id: 'f17eae2f-0ead-4340-b205-0832e94f0900',
    type: ChangeType.Tool,
    duplicated_ids: 'd651135',
    create_change_info: {
      changed_at: new Date(2022, 6, 11, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 11, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: 'f17eae2f-0ead-4340-b205-0832e94f0900',
      create_change_info: {
        changed_at: new Date(2022, 6, 12, 12, 13).toISOString(),
        created_at: new Date(2022, 6, 12, 12, 13).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Mozart',
              last_name: 'Meyer',
            },
          },
        },
      },
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      change_type: ToolChangeType.Change,
    },
  },
  {
    id: '1ec053cf-68b8-4827-b2fc-11c78c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'd1adf235',
    read: false,
    tool: {
      id: '1ec053cf-68b8-4827-b2fc-11c78c760601',
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 6, 13, 19, 40).toISOString(),
        created_at: new Date(2022, 6, 13, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Julia',
              last_name: 'Bachmann',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'Alexa',
              last_name: 'Foedde',
            },
          },
        },
      },
      change_type: ToolChangeType.Delete,
    },
    create_change_info: {
      changed_at: new Date(2022, 6, 13, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 13, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
  },
  {
    id: '1ec05e3cf-68b8-4827-b2fc-11c78c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'd13ea3df15',
    create_change_info: {
      changed_at: new Date(2022, 6, 14, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 14, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ewc053cf-68b8-4827-b2fc-11c78c760601',
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 6, 11, 19, 40).toISOString(),
        created_at: new Date(2022, 6, 14, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Holy',
              last_name: 'Deichmann',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'Alex',
              last_name: 'Zimmermann',
            },
          },
        },
      },
      change_type: ToolChangeType.Selected,
    },
  },
  {
    id: '1ec053cf-668b8-4827-b2fc-11c78c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'dadaf3v135',
    create_change_info: {
      changed_at: new Date(2022, 6, 14, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 14, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ec053cf-684b8-4827-b2fc-11c78c760601',
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 40).toISOString(),
        created_at: new Date(2022, 8, 10, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name2',
              last_name: 'Bachmann',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'Alexa2',
              last_name: 'Foedde2',
            },
          },
        },
      },
      change_type: ToolChangeType.Removed,
    },
  },
  {
    id: '1ec053cf-668b8-48327-b2fc-11c782c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'd1ae32f135',
    read: false,
    create_change_info: {
      changed_at: new Date(2022, 6, 15, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 15, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    tool: {
      id: '1ec053cf-684b8-48827-b2fc-11c7j8c760601',
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 40).toISOString(),
        created_at: new Date(2022, 8, 15, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name3',
              last_name: 'Bachmann',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'name3',
              last_name: 'Foedde2',
            },
          },
        },
      },
      change_type: ToolChangeType.Removed,
    },
  },
  {
    id: '1ec053cf-668b8-48327-1re1c782-c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'd13aef2315',
    create_change_info: {
      changed_at: new Date(2022, 6, 16, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 16, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ec053cf-684b8-48827-1re1c7j8c760601',
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 40).toISOString(),
        created_at: new Date(2022, 8, 16, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name4',
              last_name: 'Bachmann',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'FirstName4',
              last_name: 'LastName4',
            },
          },
        },
      },
      right: {
        role: 'B',
        name: 'A',
      },
      change_type: ToolChangeType.RightAssigned,
    },
  },
  {
    id: '1ec053cf-668b8-58327-1re1c782-c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'adf231d135',
    create_change_info: {
      changed_at: new Date(2022, 6, 16, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 16, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ec053cf-685b8-58827-1re1c7j8c760601',
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 50).toISOString(),
        created_at: new Date(2022, 8, 17, 18, 50).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name5',
              last_name: 'Bachmann',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'FirstName5',
              last_name: 'LastName5',
            },
          },
        },
      },
      right: {
        role: 'B',
        name: 'A',
      },
      change_type: ToolChangeType.RightRemoved,
    },
  },
  {
    id: '1ec043cf-668b8-48327-1re1c782-c760601',
    type: ChangeType.Tool,
    duplicated_ids: 'da3d21f135',
    create_change_info: {
      changed_at: new Date(2022, 6, 17, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 17, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ec043cf-684b8-48827-1re1c7j8c760601',

      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 40).toISOString(),
        created_at: new Date(2022, 8, 17, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name6',
              last_name: 'LastName6',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'FirstName6',
              last_name: 'LastName6',
            },
          },
        },
      },
      right: {
        role: 'B',
        name: 'A',
      },
      change_type: ToolChangeType.MultiSeleted,
    },
  },
  {
    id: '1ec043cf-778b8-48327-1re1c782-c770701',
    type: ChangeType.Tool,
    duplicated_ids: 'dfa21afd564',
    create_change_info: {
      changed_at: new Date(2022, 6, 18, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 18, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ec043cf-784b8-48827-1re1c7j8c770701',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 40).toISOString(),
        created_at: new Date(2022, 8, 18, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name7',
              last_name: 'LastName7',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'FirstName7',
              last_name: 'LastName7',
            },
          },
        },
      },
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      right: {
        role: 'B',
        name: 'A',
      },
      change_type: ToolChangeType.MultiAssigned,
    },
  },
  {
    id: '1ec043cf-888b8-48327-1re1c782-c780801',
    type: ChangeType.Tool,
    duplicated_ids: 'd1dfe4535',
    create_change_info: {
      changed_at: new Date(2022, 6, 18, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 18, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    tool: {
      id: '1ec043cf-884b8-48827-1re1c7j8c780801',
      create_change_info: {
        changed_at: new Date(2022, 8, 12, 19, 40).toISOString(),
        created_at: new Date(2022, 8, 19, 18, 40).toISOString(),
        created_by: {
          profile: {
            personal_data: {
              first_name: 'Name8',
              last_name: 'LastName8',
            },
          },
        },
        changed_by: {
          profile: {
            personal_data: {
              first_name: 'FirstName8',
              last_name: 'LastName8',
            },
          },
        },
      },
      tool_name: 'ToolA',
      count: 1,
      user_1_name: 'Max',
      right: {
        role: 'B',
        name: 'A',
      },
      change_type: ToolChangeType.MultiRemoved,
    },
  },

  // Chat room
  {
    id: '28hxs81h',
    type: ChangeType.Room,
    duplicated_ids: 'd1dfadfdfe4535',
    create_change_info: {
      changed_at: new Date(2022, 6, 19, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 19, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    favorite: true,
    room: {
      id: '2912jd91j',
      user_1_name: 'User 1',
      user_2_name: 'User 2',
      messages: [],
      // messages: [
      //   {
      //     id: '291jd10ß1',
      //     info: { type: InfoMessageType.invite, sub: 'Max', obj: 'Alice' },
      //     content: '',
      //     create_change_info: {
      //       changed_at: new Date(2022, 6, 10, 18, 45).toISOString(),
      //       created_at: new Date(2022, 6, 10, 18, 45).toISOString(),
      //       created_by: {
      //         profile: {
      //           avatar: {
      //             id: '209217001221',
      //             url: stock4,
      //           },
      //           personal_data: {
      //             first_name: 'Elma',
      //             last_name: 'Stahlmann',
      //           },
      //         },
      //       },
      //     },
      //     read: [],
      //   },
      // ],
      room_type: RoomType.Group,
      change_type: RoomChangeType.InviteMe,
      message_room_name: 'room2',
      settings: {
        description: 'Gruppenbeschreibung',
        name: 'P4 Dev',
      },
    },
  },
  {
    id: '28hx8d1h',
    type: ChangeType.Room,
    duplicated_ids: 'dfe354v',
    create_change_info: {
      changed_at: new Date(2022, 6, 20, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 20, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    favorite: true,
    room: {
      id: '2912jd91j',
      user_1_name: 'User 3',
      user_2_name: 'User 4',
      messages: [],
      // messages: [
      //   {
      //     id: '291jd10ß1',
      //     info: { type: InfoMessageType.close },
      //     content: '',
      //     create_change_info: {
      //       changed_at: new Date(2022, 6, 20, 18, 45).toISOString(),
      //       created_at: new Date(2022, 6, 20, 18, 45).toISOString(),
      //       created_by: {
      //         profile: {
      //           avatar: {
      //             id: '209217001221',
      //             url: stock4,
      //           },
      //           personal_data: {
      //             first_name: 'Helen',
      //             last_name: 'Bachmann',
      //           },
      //         },
      //       },
      //     },
      //     read: [],
      //   },
      // ],
      room_type: RoomType.Group,
      change_type: RoomChangeType.Close,
      message_room_name: 'room6',
      settings: {
        description: 'Gruppenbeschreibung',
        name: 'P4 Dev',
      },
    },
  },
  {
    id: '28ahxe4bd8-erfbvw5y1h',
    type: ChangeType.Room,
    duplicated_ids: 'dfe3adf54v',
    create_change_info: {
      changed_at: new Date(2022, 6, 20, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 20, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    room: {
      id: '2912-321jd91j',
      user_1_name: 'Max',
      messages: [],
      //   {
      //     id: '291jdd10ß1',
      //     info: { type: InfoMessageType.close },
      //     content: '',
      //     create_change_info: {
      //       changed_at: new Date(2022, 6, 10, 18, 45).toISOString(),
      //       created_at: new Date(2022, 6, 10, 18, 45).toISOString(),
      //       created_by: {
      //         profile: {
      //           avatar: {
      //             id: '209217001221',
      //             url: stock4,
      //           },
      //           personal_data: {
      //             first_name: 'Helen',
      //             last_name: 'Bachmann',
      //           },
      //         },
      //       },
      //     },
      //     read: [],
      //   },
      // ],
      room_type: RoomType.Group,
      change_type: RoomChangeType.InviteOthers,
      message_room_name: 'room3',
      settings: {
        description: 'Gruppenbeschreibung',
        name: 'Einstellung',
      },
    },
  },
  {
    id: '28ahxe4bd81h',
    type: ChangeType.Room,

    duplicated_ids: 'dfe3aadfddf54v',
    create_change_info: {
      changed_at: new Date(2022, 6, 21, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 21, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: true,
    room: {
      id: '2912jd91j',
      user_1_name: 'User 1',
      user_2_name: 'User 2',
      messages: [],
      // [
      //   {
      //     id: '291jd10ß1',
      //     info: {
      //       type: InfoMessageType.remove,
      //       sub: 'Max',
      //       obj: 'Lina Weber',
      //     },
      //     content: '',
      //     create_change_info: {
      //       changed_at: new Date(2022, 6, 21, 18, 45).toISOString(),
      //       created_at: new Date(2022, 6, 21, 18, 45).toISOString(),
      //       created_by: {
      //         profile: {
      //           avatar: {
      //             id: '209217001221',
      //             url: stock4,
      //           },
      //           personal_data: {
      //             first_name: 'Hans',
      //             last_name: 'Schmidt',
      //           },
      //         },
      //       },
      //     },
      //     read: [],
      //   },
      // ],
      room_type: RoomType.Group,
      change_type: RoomChangeType.Removed,
      message_room_name: 'Einstellung',
      settings: {
        description: 'Gruppenbeschreibung',
        name: 'Einstellung',
      },
    },
  },
  {
    id: '28hx8d1hf',
    type: ChangeType.Room,
    duplicated_ids: 'dfe3aadfde4354v',
    create_change_info: {
      changed_at: new Date(2022, 6, 21, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 21, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    favorite: true,
    room: {
      id: '2912jd91j',
      user_1_name: 'User 1',
      user_2_name: 'User 2',
      message_room_name: 'room2',
      messages: [],
      // {
      //   id: '291jd10ß1',
      //   content:
      //     'Hallo Hubert, Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut, consetetur sadipscing elitr.',
      //   create_change_info: {
      //     changed_at: new Date(2022, 6, 10, 18, 45).toISOString(),
      //     created_at: new Date(2022, 6, 10, 18, 45).toISOString(),
      //     created_by: {
      //       profile: {
      //         avatar: {
      //           id: '209217001221',
      //           url: stock4,
      //         },
      //         personal_data: {
      //           first_name: 'Emma',
      //           last_name: 'Schwarz',
      //         },
      //       },
      //     },
      //   },
      // read: [],
      // },
      // ],
      room_type: RoomType.Direct,
      change_type: RoomChangeType.Sticky,
    },
  },
  {
    id: '28hxdfs81h',
    type: ChangeType.Room,
    duplicated_ids: '354advhk',
    create_change_info: {
      changed_at: new Date(2022, 6, 23, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 23, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    room: {
      id: '2912jd91j',
      user_1_name: 'User 1',
      user_2_name: 'User 2',
      messages: [],
      //   {
      //     id: '291jd10ß1',
      //     info: {
      //       type: InfoMessageType.leave,
      //     },
      //     content: '',
      //     create_change_info: {
      //       changed_at: new Date(2022, 6, 23, 18, 45).toISOString(),
      //       created_at: new Date(2022, 6, 23, 18, 45).toISOString(),
      //       created_by: {
      //         profile: {
      //           avatar: {
      //             id: '209217001221',
      //             url: stock2,
      //           },
      //           personal_data: {
      //             first_name: 'Emma',
      //             last_name: 'Schwarz',
      //           },
      //         },
      //       },
      //     },
      //     read: [],
      //   },
      // ],
      message_room_name: 'room4',
      room_type: RoomType.Direct,
      change_type: RoomChangeType.Leave,
    },
  },
  {
    id: '28hxd54gbvfs81h',
    type: ChangeType.Room,
    duplicated_ids: 'df98erv',
    create_change_info: {
      changed_at: new Date(2022, 6, 23, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 23, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: true,
    room: {
      id: '2912jerv4d91j',
      user_1_name: 'User 1',
      user_2_name: 'User 2',
      messages: [
        // {
        //   id: '291jd44ffb-10ß1',
        //   info: { type: InfoMessageType.close },
        //   content: '',
        //   create_change_info: {
        //     changed_at: new Date(2022, 6, 10, 18, 45).toISOString(),
        //     created_at: new Date(2022, 6, 10, 18, 45).toISOString(),
        //     created_by: {
        //       profile: {
        //         avatar: {
        //           id: '209217001221',
        //           url: stock4,
        //         },
        //         personal_data: {
        //           first_name: 'Helen',
        //           last_name: 'Bachmann',
        //         },
        //       },
        //     },
        //   },
        //   read: [],
        // },
      ],
      message_room_name: 'room5',
      room_type: RoomType.Direct,
      change_type: RoomChangeType.Mention,
    },
  },
  {
    id: '28hxd54gbvfsd81h',
    type: ChangeType.Room,
    duplicated_ids: 'df98erv',
    create_change_info: {
      changed_at: new Date(2022, 6, 23, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 23, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: false,
    room: {
      id: '2912jerv4d91j',
      user_1_name: 'Sascha Landowski',
      user_1_avatar:
        'https://files.pengueen.de/api/download/c5449ee2-b2e8-475f-a49a-5539c2d528bd.jpg',
      user_2_name: 'User 2',
      messages: [
        `<p>Ihr Lieben,<br>aktuell ist LinkedIn unsere Haupt-Kommunikationsplattform 'nach außen' ..<br>ich möchte euch bitte, wenn ihr LinkedIn nutzt, uns, also Pengueen zu folgen und ab und zu unsere Beiträge zu liken und zu teilen.<br>Auch gut fänd ich, wenn ihr markiert, dass ihr 'hier' beschäftigt seid.<br>Danke 🌞</p>`,
      ],
      message_room_name: 'room5',
      room_type: RoomType.Direct,
      change_type: RoomChangeType.NewMessage,
    },
  },
  // Contact
  {
    id: '28hxfds81h',
    type: ChangeType.Contact,
    duplicated_ids: 'df9adf8erv',
    create_change_info: {
      changed_at: new Date(2022, 6, 10, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 10, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: true,
    contact: {
      id: 'cxkmwd908h1wd',
      user_1_name: 'Liam Braun',
      user_2_name: 'Liam Braun',
      // state: ActiveState.Active,
      // avatar: {
      //   id: 's91j219j12d',
      //   url: stock6,
      // },
      direct_room_id: '210ßdk1390ud1',
      // create_change_info: {
      //   changed_at: new Date(2023, 6, 10, 18, 45).toISOString(),
      //   created_at: new Date(2023, 6, 10, 18, 45).toISOString(),
      //   created_by: {
      //     profile: {
      //       avatar: {
      //         id: '209217001221',
      //         url: stock6,
      //       },
      //       personal_data: {
      //         first_name: 'Liam',
      //         last_name: 'Braun',
      //       },
      //     },
      //   },
      // },
      change_type: ContactChangeType.Accepted,
    },
  },
  {
    id: 'a28hxfds81h',
    type: ChangeType.Contact,
    duplicated_ids: 'df98efae64rv',
    create_change_info: {
      changed_at: new Date(2022, 6, 10, 19, 40).toISOString(),
      created_at: new Date(2022, 6, 10, 18, 40).toISOString(),
      created_by: {
        profile: {
          personal_data: {
            first_name: 'Julia',
            last_name: 'Bachmann',
          },
        },
      },
    },
    read: true,
    favorite: true,
    contact: {
      id: '3cxkmwd908h1wd',
      user_1_name: 'Kian Rot',
      user_2_name: 'Kian Rot',
      // state: ActiveState.Active,
      // avatar: {
      //   id: 'ts91j219j12d',
      //   url: stock5,
      // },
      direct_room_id: '210ß1dk1390ud1',
      // create_change_info: {
      //   changed_at: new Date(2023, 6, 11, 18, 45).toISOString(),
      //   created_at: new Date(2023, 6, 11, 18, 45).toISOString(),
      //   created_by: {
      //     profile: {
      //       avatar: {
      //         id: '2092137001221',
      //         url: stock6,
      //       },
      //       personal_data: {
      //         first_name: 'Kian',
      //         last_name: 'Rot',
      //       },
      //     },
      //   },
      // },
      change_type: ContactChangeType.Rejected,
    },
  },
];

export const useDashboardMock = () => {
  /**
   * GET Communities mock data.
   * @returns Communities mock data.
   * @deprecated To be removed.
   */
  const communitiesGet = (): DashboardCommunity[] => {
    return [
      {
        changes: 4,
        community: {
          id: 'c001',
          logo: {
            id: '210jnc981',
            url: stock2,
          },
          name: 'airbnb',
        },
      },
      {
        changes: 9,
        community: {
          id: 'c002',
          logo: {
            id: '2314134jnc981',
            url: stock1,
          },
          name: 'Gemeinschaftsname',
        },
      },
      {
        changes: 0,
        community: {
          id: 'c003',
          logo: {
            id: '3215425421',
            url: stock2,
          },
          name: 'Pengueen',
        },
      },
      {
        changes: 0,
        community: {
          id: 'c004',
          logo: {
            id: '2214314012414jnc981',
            url: stock3,
          },
          name: 'Slack',
        },
      },
      {
        changes: 12,
        community: {
          id: 'c005',
          logo: {
            id: '190219hd98h1d',
            url: stock1,
          },
          name: 'Microsoft',
        },
      },
      {
        changes: 2,
        community: {
          id: 'c006',
          logo: {
            id: 'vcmq82n1',
            url: stock2,
          },
          name: 'Berlin',
        },
      },
      {
        changes: 2,
        community: {
          id: 'c007',
          logo: {
            id: 'cxmc9u1089hd1',
            url: stock2,
          },
          name: 'Hamburg',
        },
      },
      {
        changes: 0,
        community: {
          id: 'c008',
          logo: {
            id: 'smx90812nd',
            url: stock1,
          },
          name: 'Blau',
        },
      },
    ];
  };

  /**
   * GET Favorite groups / users mock data.
   * @returns Favorite groups / users mock data.
   * @deprecated To be removed.
   */
  // const favoriteGroupsUsersGet = (): Favorite[] => {
  //   return [
  //     {
  //       user: {
  //         id: '182791762',
  //         avatar: {
  //           id: '182781721',
  //           url: stock6,
  //         },
  //         link: FavoriteLinkType.Contacts,
  //         first_name: 'Klara-Petra-Klara',
  //         last_name: 'Kollakowski',
  //         unread_msgs: 2,
  //       },
  //     },
  //     {
  //       user: {
  //         id: 'c92u091u',
  //         avatar: {
  //           id: 's09w1j31w8h',
  //           url: stock4,
  //         },
  //         link: FavoriteLinkType.Newscenter,
  //         first_name: 'Hubertus',
  //         last_name: 'Meyer',
  //         unread_msgs: 4,
  //       },
  //     },
  //     {
  //       group: {
  //         id: '2017dcm1-2132',
  //         name: 'Begleitungsgruppe',
  //         link: FavoriteLinkType.Newscenter,
  //         unread_msgs: 15,
  //         users: [
  //           {
  //             id: '201id-291hd',
  //             avatar: {
  //               id: 's09w1j31w8h',
  //               url: stock4,
  //             },
  //             first_name: 'Klara',
  //             last_name: 'Kowski',
  //           },
  //           {
  //             id: '112232434',
  //             avatar: {
  //               id: '3901ud1jh122',
  //               url: stock6,
  //             },
  //           },
  //           {
  //             id: 'aaa35zh23232',
  //             avatar: {
  //               id: 'sasdasd13d1d',
  //               url: stock4,
  //             },
  //             first_name: 'Hubertus',
  //             last_name: 'Meyer',
  //           },
  //           {
  //             id: '998u1ju29j-22414',
  //             avatar: {
  //               id: 'diow1921j',
  //               url: stock5,
  //             },
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       user: {
  //         id: 'ss0s90i1-212414',
  //         avatar: {
  //           id: '291u09ju121',
  //           url: stock6,
  //         },
  //         link: FavoriteLinkType.Contacts,
  //         first_name: 'Klara-Petra',
  //         last_name: 'Kollameyerkowsihubert',
  //       },
  //     },
  //     {
  //       user: {
  //         id: '2141414',
  //         avatar: {
  //           id: '3141341341',
  //           url: stock5,
  //         },
  //         link: FavoriteLinkType.Newscenter,
  //         unread_msgs: 7,
  //       },
  //     },
  //     {
  //       user: {
  //         id: '1ss122244567899',
  //         avatar: {
  //           id: '988884575756',
  //           url: stock6,
  //         },
  //         link: FavoriteLinkType.Contacts,
  //         first_name: 'Klara-Petra',
  //         last_name: 'Kollakowski',
  //       },
  //     },
  //   ];
  // };

  /**
   * GET Favorite tools mock data.
   * @returns Favorite tools mock data.
   * @deprecated To be removed.
   */
  const favoriteToolsGet = (): ToolFavorite[] => {
    return [
      {
        id: '210dj012sad',
        changes: 2,
        community: {
          data: {
            id: '2ß1ldj2d1ß',
            logo: {
              id: '291jd91212',
              url: stock1,
            },
            name: 'airbnb',
          },
        },
        name: '$Hilfsmittelbezeichnung',
        template: {
          icon: {
            id: '291u021',
            url: stock2,
          },
          name: '$Hilfsmittelvorlagennamenamenamenamename',
        },
      },
      {
        id: 'ls81hw17',
        changes: 10,
        community: {
          data: {
            id: 'c987312h98d',
            logo: {
              id: 'd789h1d89hd12',
              url: stock1,
            },
            name: 'airbnb',
          },
        },
        name: 'Das ist eine lange Beispielbezeichnung für Hilfsmittel, um mehr Platz einzunehmen',
        template: {
          icon: {
            id: '2922910u2910u',
            url: stock3,
          },
          name: '$Kategoriename',
        },
      },
      {
        id: '2012u92u1sasqqw',
        name: 'Dies ist eine kurze Beschreibung',
        template: {
          icon: {
            id: '202710712',
            url: stock3,
          },
          name: '$Kategoriename',
        },
      },
      {
        id: '44545435',
        name: 'Das ist eine lange Beispielbezeichnung für Hilfsmittel, um mehr Platz einzunehmen',
        template: {
          icon: {
            id: '2021092u1',
            url: stock2,
          },
          name: '$Kategoriename',
        },
      },
      {
        id: '210ßdwiußciufzu310',
        name: 'Dies ist eine kurze Beschreibung',
        template: {
          icon: {
            id: '202128ß122',
            url: stock1,
          },
          name: '$Kategoriename',
        },
      },
      {
        id: 'aaaldkcid8we8',
        name: 'Dies ist eine kurze Beschreibung',
        template: {
          icon: {
            id: '2021282121ß21912ß122',
            url: stock3,
          },
          name: '$Kategoriename',
        },
      },
      {
        id: '2109217d890w0ß21ki32r90t4u',
        name: 'Dies ist eine kurze Beschreibung',
        template: {
          icon: {
            id: 'ppouzt',
            url: stock2,
          },
          name: '$Kategoriename',
        },
      },
    ];
  };

  /**
   * GET Editor's recommendation
   * @returns Editor's recommendation mock data.
   */
  const RecommendationTemplatesMockGet = (): MarketTemplate[] => {
    return [
      {
        id: 'd13eb7a6-a153-41ea-bc2e-0350968944ad',
        preview_id: '88a243d8-b6e2-4320-a881-28a83ceb237f',
        image_market: {
          id: '6f5ae03c-7a3f-4fe7-a63f-49e14a96642d',
          url: 'https://files.pengueen.de/api/download/116550f3-5a9d-4916-bdc4-1aa192df33fc.jpeg',
        },
        settings: {
          description:
            'Verwalte deine Tickets für IT-Projekte, Kundenanfragen und mehr. ',
          name: 'Ticketsystem',
          icon: {
            id: '163',
            url: '/static/media/ka_umfrage.a8313c9b352a2495289e5a73ac0030aa.svg',
          },
          extra: {
            restricted: false,
            unique: false,
          },
          purpose: undefined,
        },
        use_case: TemplateUseCase.Project_Management,
        status: [TemplateStatus.Published],
        types: [TemplateType.Public],
      },
      {
        id: '3aed4d4f-fb24-4dd1-b443-ae53e1d17315',
        preview_id: 'e7592e12-e82d-4e18-8188-0eaadbdaa9f2',
        image_market: {
          id: '376ec82c-cb42-407e-bca9-acf9d83fbcc9',
          url: 'https://files.pengueen.de/api/download/0e9379b0-d4e9-450d-a5a6-076054eb7d94.jpeg',
        },
        settings: {
          description:
            'Übersicht aller eingegangen Anrufe Liste sowie Verwaltung und Bearbeitung dieser.',
          name: 'Telefonliste',
          icon: {
            id: '58',
            url: '/static/media/ka_feedback-zur-Nutzung.c62a8e8b20d52f1006c8ebc8c20ae729.svg',
          },
          extra: {
            restricted: false,
            unique: false,
          },
          purpose: undefined,
        },
        use_case: TemplateUseCase.Documentation,
        status: [TemplateStatus.Published],
        types: [TemplateType.Public],
      },
      {
        id: 'e84bada8-5508-45bc-8ed5-d32d8b33a0c4',
        preview_id: '5a8023a9-70c3-4a32-aee7-dd53c3e9c5aa',
        image_market: {
          id: '2ab891fd-a742-4fc0-a331-3504df44e5ae',
          url: 'https://files.pengueen.de/api/download/47610fc3-7bed-4016-a34a-b1026b131fd9.jpeg',
        },
        settings: {
          description:
            'Hilft dir unternehmensweite Dokumente zu hinterlegen. Über die Zugriffsrechte kannst du bestimmen, welcher Nutzer Zugriff erhalten sollen.',
          name: 'Dateiablage',
          icon: {
            id: '44',
            url: '/static/media/ka_dokument.f62e1d03c605095eaa76ecb237235195.svg',
          },
          extra: {
            restricted: false,
            unique: false,
          },
          purpose: undefined,
        },
        use_case: TemplateUseCase.Other,
        status: [TemplateStatus.Published],
        types: [TemplateType.Public],
      },
      {
        id: 'b8031f05-6d53-446f-97dc-ae07a5ddb381',
        preview_id: '2297369a-8cc2-4375-975e-e2bd13daa9db',
        image_market: {
          id: 'b726fd1d-e2a7-4492-b6a5-9ee60dba3f6f',
          url: 'https://files.pengueen.de/api/download/a62999da-e4de-4613-ab92-913f4dbd3acb.jpeg',
        },
        settings: {
          description: 'Erstelle Umfragen für Nutzer zu bestimmten Themen.',
          name: 'Mitarbeiterumfrage',
          icon: {
            id: '58',
            url: '/static/media/ka_feedback-zur-Nutzung.c62a8e8b20d52f1006c8ebc8c20ae729.svg',
          },
          extra: {
            restricted: false,
            unique: false,
          },
          purpose: undefined,
        },
        use_case: TemplateUseCase.Other,
        status: [TemplateStatus.Published],
        types: [TemplateType.Public],
      },
      {
        id: '998cd9a4-6539-4d73-a549-4b8c3f60afa7',
        preview_id: '08e1f323-3d3c-4b74-928a-2c2f0a87fc72',
        image_market: {
          id: 'f2ea0b9e-8736-4b73-aefb-ce35a936d006',
          url: 'https://files.pengueen.de/api/download/58443c9d-d86d-4d3e-9e30-5bb668781b97.png',
        },
        settings: {
          description: 'Aufgabenverwaltung',
          name: 'Aufgabenverwaltung',
          icon: {
            id: '2',
            url: 'data:image/png;base64,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',
          },
          extra: {
            restricted: false,
            unique: false,
          },
          purpose: undefined,
        },
        use_case: TemplateUseCase.Project_Management,
        status: [TemplateStatus.Published],
        types: [TemplateType.Public],
      },
    ];
  };
  return {
    changesGet: changesMock,
    communitiesGet,
    // favoriteGroupsUsersGet,
    favoriteToolsGet,
    RecommendationTemplatesMockGet,
  };
};
